<template>
    <div class="md-layout md-gutter">
        <md-card class="md-card-profile md-layout-item md-size-33 carding md-small-size-100">
            <div class="md-card-avatar">
                <img class="img" src="../assets/img/vue-logo.png" />
            </div>
            <md-card-content>

                <h6 class="category text-gray">Blink Offer</h6>
                <h4 class="card-title">LOG IN OR SIGN UP</h4>
                <p class="card-description">
                    Hello, this is the sellers platform for the app <br />
                    If you have a shop and are running offers, this is the best way to get
                    users to know about them
                    <br />
                    <br />
                </p>

                <pulse-loader :loading="loading" :color="color" > </pulse-loader>

                <form v-show="login" id="details">
                    <div class="md-layout-item md-small-size-100 md-size-100">
                        <md-field>
                            <label>Email</label>
                            <md-input v-model="email" type="email"> </md-input>
                        </md-field>
                    </div>

                    <div class="md-layout-item md-small-size-100 md-size-100">
                        <md-field>
                            <label>Password</label>
                            <md-input v-model="password" type="password"> </md-input>
                        </md-field>
                    </div>

                    <div class="md-layout-item md-small-size-100 md-size-100" v-show="signUp">
                        <md-field>
                            <label>Confirm Password</label>
                            <md-input v-model="cPassword" type="password"> </md-input>
                        </md-field>
                    </div>

                    <div class="md-layout-item md-size-100 text-center">
                        <md-button class="md-raised md-primary" @click="signIn">{{signUp ? 'create account' : 'log in your account'}}</md-button>
                    </div>

                    <p class="purple">
                        <br>
                        ---
                        <br>
                        or
                    </p>

                    <div class="md-layout-item md-size-100 text-center">
                        <md-button class="md-raised"  @click="signUp=!signUp">{{ signUp ? 'sign in' : 'sign up' }}</md-button>
                    </div>

                    <md-snackbar  :md-duration="Infinity" :md-active.sync="showSnackbar" md-persistent>
                        <span>{{message}}</span>
                        <md-button @click="showSnackbar = false">OK</md-button>
                    </md-snackbar>

                </form>

            </md-card-content>
        </md-card>
    </div>
</template>

<script>

    import firebase from "../Firebase";
    import PulseLoader from 'vue-spinner/src/PulseLoader.vue';

    export default {
        name: "Welcome",
        components : {PulseLoader},
        data(){
            return{
                loading : true,
                color : "purple",
                login : false,
                signUp : false,
                showSnackbar : false,
                email : "",
                password : "",
                cPassword : "",
                message : ""

            }
        },created() {
            let auth = firebase.auth();
            auth.onAuthStateChanged( user => {
                console.log(user);
                if (user) {
                    window.location.href = "#/dashboard";
                    this.login = false;
                }else{
                    this.loading = false;
                    this.login = true;
                }
            });
        }, methods : {
            signIn(){
                if (this.signUp){

                    if(this.password === this.cPassword && this.email && this.password){

                        this.loading = true;
                        firebase.auth().setPersistence(firebase.auth.Auth.Persistence.LOCAL)
                            .then(__ => {
                                firebase.auth().createUserWithEmailAndPassword(this.email, this.password)
                                    .catch(error => {
                                        this.message = error.message;
                                        this.loading = false;
                                        this.showSnackbar = true;
                                    })
                            });

                    }

                }else{

                    if(this.email && this.password){

                        this.loading = true;
                        firebase.auth().setPersistence(firebase.auth.Auth.Persistence.LOCAL)
                            .then( __ => {
                                return firebase.auth().signInWithEmailAndPassword(this.email, this.password)
                                    .catch(error => {
                                        this.message = error.message;
                                        this.loading = false;
                                        this.showSnackbar = true;
                                    })
                            }).catch(error => {
                                this.message = error.message;
                                this.loading = false;
                                this.showSnackbar = true;
                            });
                    }

                }
            }
        }
    };

</script>

<style>
    .carding {
        margin: 70px auto !important;
    }
    .purple{
        color: purple;
    }
</style>
